import Section from "../../../components/Section";
import Avatar from "../../../components/Avatars";
import {
  AppStoreButton,
  AppStoreInfo,
  AppStoreType,
  Description,
  Game,
  Preview,
  Thumbnails,
} from "../../../components/GamePage";

import styles from "./index.module.scss";
import { GamesBoatBashers } from "../../../constants/links";
import { ReactNode } from "react";
import { Helmet } from "react-helmet";

const Subtitle = "Bash and smash your way to the top";

const Buttons = [
  <AppStoreButton
    className={styles.appStoreMobileButtons}
    href="https://apps.apple.com/lt/app/boat-bashers/id6749868006"
    appStore={AppStoreType.apple}
  />,
  <AppStoreButton
    className={styles.appStoreMobileButtons}
    href="https://play.google.com/store/apps/details?id=com.CozyLabs.BoatBashers"
    appStore={AppStoreType.android}
  />,
];

export const BoatBashersPreview = ({}: {}) => {
  return (
    <Preview
      titleSrc={"/assets/images/games/boat_bashers/logo_boat_bashers.png"}
      cardSrc={"/assets/images/games/boat_bashers/bg.png"}
      subtitle={Subtitle}
      href={GamesBoatBashers}
    />
  );
};

const BoatBashersGame = ({ buttons }: { buttons: ReactNode[] }) => {
  const unityConfig = {
    loaderUrl: "/assets/build/boat_bashers/WebGL.loader.js",
    dataUrl: "/assets/build/boat_bashers/WebGL.data",
    frameworkUrl: "/assets/build/boat_bashers/WebGL.framework.js",
    codeUrl: "/assets/build/boat_bashers/WebGL.wasm",
  };

  return (
    <Game
      unityConfig={unityConfig}
      titleSrc={"/assets/images/games/boat_bashers/logo_boat_bashers.png"}
      subtitle={Subtitle}
      buttons={buttons}
    />
  );
};

const BoatBashersHero = ({
  children,
  playable = true,
}: {
  children?;
  playable?: boolean;
}) => {
  return (
    <Section className={styles.hero}>
      <Helmet>
        <title>Cozyverse | Play Boat Bashers</title>
        <meta name="apple-itunes-app" content="app-id=6450430184" />
      </Helmet>
      {playable ? (
        <BoatBashersGame buttons={Buttons} />
      ) : (
        <BoatBashersPreview />
      )}
      {children}
      <Avatar
        img="/assets/images/games/boat_bashers/ground.png"
        hideMobile
        style={{
          bottom: "-0.5rem",
          width: "101%",
        }}
      />
      <Avatar
        img="/assets/images/games/boat_bashers/cozy.png"
        hideMobile
        style={{
          bottom: "1rem",
          left: "2rem",
          maxWidth: "27%",
        }}
      />
      <Avatar
        img="/assets/images/games/boat_bashers/boats.png"
        hideMobile
        style={{
          bottom: "-1.5rem",
          right: "-7%",
          maxWidth: "21%",
        }}
      />
    </Section>
  );
};

const BoatBashersPage = () => {
  return (
    <div className={styles.root}>
      <BoatBashersHero playable={true} />
      <Section className={styles.about}>
        <AppStoreInfo
          iconImg="/assets/images/games/boat_bashers/icon_boat_bashers.png"
          buttons={[
            <AppStoreButton
              className={styles.appStoreDesktopButtons}
              href="https://apps.apple.com/lt/app/boat-bashers/id6749868006"
              appStore={AppStoreType.apple}
            />,
            <AppStoreButton
              className={styles.appStoreDesktopButtons}
              href="https://play.google.com/store/apps/details?id=com.CozyLabs.BoatBashers"
              appStore={AppStoreType.android}
            />,
          ]}
        />
        <Description>
          <p>
            Smash your way to the top in Boat Bashers, an arcade game where you
            smash as many boats in the boatyard before the time runs out.
          </p>
          <p>
            Smash boats, collect power ups, and dodge fish in this casual but
            fast-paced hit.
          </p>
          <h3>How to Play</h3>
          <p>
            Smash the boats by pressing the left and right key until the time
            runs out. Gain time by smashing the boats, and dodge the obstacles
            that will stun you. Collect power ups to increase time and earn more
            points!
          </p>
          <p>
            {" "}
            *Mobile browser not supported. Download the app on Apple App Store
            and Google Play.
          </p>
        </Description>
        {/* <Thumbnails>
          <img src="/assets/images/games/land_slide/1.png" />
          <img src="/assets/images/games/land_slide/2.png" />
          <img src="/assets/images/games/land_slide/3.png" />
          <img src="/assets/images/games/land_slide/4.png" />
        </Thumbnails> */}
        <Avatar
          img="/assets/images/games/shared/ducks.png"
          hideMobile
          style={{
            left: "-15rem",
            bottom: "-10rem",
          }}
        />
        <Avatar
          img="/assets/images/games/shared/ducks.png"
          hideMobile
          style={{
            right: "-15rem",
            top: "-10rem",
          }}
        />
      </Section>
    </div>
  );
};

export { BoatBashersPage, BoatBashersHero };
